<template>
    <div style="user-select: none">
        <a-alert class="mb-5" message="Os menus são catalogados. Encontre o que se adequa aos seus produtos" type="info" show-icon />
        <div class="flex items-center mb-6 mx-5">
            <span class="mr-5"><b>Procurar</b></span>
            <a-input v-model="searchText">
                <a-icon v-show="filteredCategories.length" slot="suffix" type="search" />
            </a-input>
        </div>

            <a-tabs
                default-active-key="all"
                tab-position="left"
                @change="setActive"
                >

                <a-tab-pane v-for="categorie in orderedCategories" :key="categorie.id" :tab="categorie.description">
                    <VuePerfectScrollbar class="limit-height">
                        <div class="flex flex-wrap w-full">

                            <vx-card v-for="menu in filteredCategories" :key="menu.description"
                                class="item m-2 shadow-drop text-center" :class="{ 'used' : menu.used }" no-shadow
                                @click="addMenu(menu)">

                                <div class="flex vx-col items-center justify-center" style="flex-direction: column">

                                    <vue-mdi :icon="menu.icon" :size="1.25" color="#d92323"/>

                                    <div class="mt-2" style="font-size: 10pt" >
                                            <v-clamp :max-lines="2">
                                                {{ menu.description }}
                                            </v-clamp>
                                    </div>

                                </div>
                            </vx-card>

                        </div>
                        <div v-if="!busy"
                            class="flex justify-center mt-8">
                            <h4 v-show="!filteredCategories.length" style="opacity: 0.5">Sem resultados</h4>
                        </div>
                        <div v-else
                            class="flex justify-center mt-8">
                            <h4>Carregando...</h4>
                        </div>
                    </VuePerfectScrollbar>
                </a-tab-pane>
            </a-tabs>
        </div>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    import VClamp from 'vue-clamp'
    import util from '@/assets/utils/misc.js';
    import { categories } from './menus';
    import { mapActions, mapMutations, mapState } from 'vuex';

    export default {
        components: {
            VuePerfectScrollbar,
            VClamp
        },
        props: {
            existentMenus: {
                type: Array,
                default: () => []
            },
        },
        watch: {
            existentMenus () {
                this.$nextTick(() => {
                    this.groupMenus();
                });
            }
        },
        data() {
            return {
                activeTab: 'all',
                searchText: '',
                categories,
                menusByCategory: {},
                busy: true
            }
        },
        computed: {
            orderedCategories () {
                return  [ ...this.categories ].sort((a, b) => {
                    if (a.last || b.first) return 1;
                    if (b.last || a.first) return -1;
                    return (a.description > b.description) - (a.description < b.description);
                });
            },
            filteredCategories () {
                if (!this.searchText.length)
                    return this.menusByCategory[this.activeTab] || [];

                return this.menusByCategory[this.activeTab].filter(i =>
                    util.removeSpecialChars(i.description).toUpperCase().includes(util.removeSpecialChars(this.searchText).toUpperCase())
                );
            },
            ...mapState('menus', ['menus'])
        },
        methods: {
            setActive (val) {
                this.activeTab = val;
            },
            filter (items) {
                if (this.searchText.lenght)
                    return items;

                return items.filter(i =>
                    util.removeSpecialChars(i.description).toUpperCase().includes(util.removeSpecialChars(this.searchText).toUpperCase())
                );
            },
            defaultMenuFilter (menus) {
                menus.forEach(m => {
                    if (this.existentMenus.find(e => e.id === m.id))
                        this.setMenusAsUsed(m)
                });
                return [ ...menus ]
                    .sort((a, b) => (a.description > b.description) - (a.description < b.description));
            },
            groupMenus () {
                this.categories.forEach(c => {
                    this.$set(
                        this.menusByCategory,
                        c.id,
                        this.defaultMenuFilter(
                            this.menus.filter(m => m.categories.find(x => x == c.id))
                        )
                    );
                });
                this.$set(this.menusByCategory, 'all', this.defaultMenuFilter(this.menus));
            },
            addMenu (menu) {
                if (menu.used)
                    return;
                this.$emit('add', menu);
            },
            ...mapActions('menus', ['fetchMenus']),
            ...mapMutations('menus', ['setMenusAsUsed'])
        },
        async mounted () {
            try {
                await this.fetchMenus();
                this.groupMenus();
            } finally {
                this.busy = false;
            }
        },
    }
</script>

<style lang="scss" scoped>
.item {
    width: 100px;
    height: 90px;
    cursor: pointer;
    margin: 1px;
    user-select: none;
}
.item:hover {
    border: 1px solid #ffc8c8;
    border-radius: 5px;
}
.used {
    opacity: 0.75;
    cursor: initial;
}
.used:hover {
    border: none;
}
.limit-height {
    max-height: 60vh;
    overflow-y: auto;
}
</style>